<template>
  <aside class="app-sidebar">
    <ul class="app-menu">
      <li>
        <router-link to="/Dashboard" class="app-menu__item">
          <i class="app-menu__icon fas fa-tachometer-alt"></i>
          <span class="app-menu__label">หน้าแรก</span>
        </router-link>
      </li>
      <li>
        <router-link to="/Repairs" class="app-menu__item">
          <!-- <i class="app-menu__icon fas fa-list"></i> -->
          <i class="app-menu__icon fas fa-list"></i>
          <span class="app-menu__label">รายการบริการไอที</span>
        </router-link>
      </li>
      <li>
        <router-link to="/Notify" class="app-menu__item">
          <i class="app-menu__icon fas fa-tools"></i>
          <span class="app-menu__label">แจ้งบริการไอที </span>
        </router-link>
      </li>
      <li>
        <router-link to="/ReportMonthly" class="app-menu__item">
          <i class="app-menu__icon fas fa-chart-area"></i>
          <span class="app-menu__label">รายงานรายเดือน</span>
        </router-link>
      </li>
      <li>
        <router-link to="/Report" class="app-menu__item">
          <i class="app-menu__icon fas fa-pencil-alt"></i>
          <span class="app-menu__label">ตารางนอกเวลาราชการ</span>
        </router-link>
      </li>
      <li v-if="roleName === 'Admin'">
        <router-link to="/Users" class="app-menu__item">
          <i class="app-menu__icon fas fa-users"></i>
          <span class="app-menu__label">ผู้ใช้งาน</span>
        </router-link>
      </li>
      <li v-if="roleName === 'Admin'">
        <router-link to="/Departments" class="app-menu__item">
          <i class="app-menu__icon fas fa-building"></i>
          <span class="app-menu__label">หน่วยงาน</span>
        </router-link>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {
    user() {
      return this.$store.state.Auth.user?.user || null;
    },
    roleName() {
      return this.$store.getters.roleName;
    },
  },
  mounted() {},
  filters: {
    trimEllip: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.length > 18 ? value.substring(0, 15) + "..." : value;
    },
  },
  methods: {
    toggleSidebar(event) {
      event.preventDefault();
      document.body.classList.toggle("sidenav-toggled");
    },
  },
  created() {
  },
};
</script>

<style scoped>
.app-sidebar {
  padding-top: 50px;
}
</style>>
